import { Subtenant } from '@bioliberty/lifemind';
import { Ellipsis, Pencil } from 'lucide-react';
import { IconButton } from '../../components/Button/IconButton';
import { DialogTrigger } from '../../components/Dialog';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '../../components/DropdownMenu';
import { EditClinicDialog } from './EditClinicDialog';

interface ClinicTableActionsProps {
  clinic: Subtenant;
}

export function ClinicTableActions({ clinic }: ClinicTableActionsProps) {
  return (
    <EditClinicDialog clinic={clinic}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <IconButton icon={Ellipsis} variant="transparent" />
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuLabel>Actions</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DialogTrigger asChild>
            <DropdownMenuItem>
              <Pencil />
              <span>Edit</span>
            </DropdownMenuItem>
          </DialogTrigger>
        </DropdownMenuContent>
      </DropdownMenu>
    </EditClinicDialog>
  );
}
